import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Analytics
import mixpanel from 'mixpanel-browser';

// Components
import PriceOptions from "../components/common/PriceOptions";

const Checkout = ({}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);
      
    useEffect(() => {
          
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
    
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);
    
    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };
    
    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
        mixpanel.track("Checkout Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    return (
        <div id="pricing" style={{padding: `${isMobile ? '1rem' : '3rem 1rem'}`, boxSizing: 'border-box', maxWidth: '64rem', marginLeft: 'auto', marginRight: 'auto'}}>
            {/* Section Header */}
            <div style={{marginBottom: '2rem'}}>
                {/* Description - Header */}
                <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500, margin: '0'}}>
                    Subscribe to Interview Cheater
                </p>
                {/* Title - Header */}
                <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginTop: '.25rem'}}>
                    Choose your plan
                </h2>
            </div>
            {/* Price Options */}
            <PriceOptions />
            <div style={{marginTop: '3rem', display: 'flex', justifyContent: 'center'}}>
                <Link to="/report-issues">
                    <button className="yellow_hover" style={{background: 'rgb(0,0,0,.3)', color: 'rgb(156,156,156)', fontWeight: 600, fontSize: '.875rem', padding: '.5rem 1rem', borderRadius: '.75rem', height: '2.75rem', border: 'none', cursor: 'pointer'}}>
                        Issues paying with Stripe?
                    </button>
                </Link>
            </div>

            {/* Spacer - add space to bottom of screen for better scroll experience */}
            {isMobile && <div style={{height: '100px'}}></div>}
        </div>
    );
};

export default Checkout;
  
